import { resources } from "@constants/hardcoded-strings";
import { AxnDocumentationLink } from "@idw-types/data/reference-data/axn";
import styles from "./content-page-header-documentation-link.less";

type ContentPageHeaderDocumentationLinkProps = {
    documentationLinks: Array<AxnDocumentationLink>;
    shortName: string;
};

export const ContentPageHeaderDocumentationLink = (props: ContentPageHeaderDocumentationLinkProps) => {
    const {
        documentationLinks,
        shortName
    } = props;

    if (documentationLinks) {
        const docLink = documentationLinks.find(dl => dl.shortName === shortName);
        if (docLink) {
            return (
                <div className={styles.documentationLinkContainer}>
                    <a href={docLink.url} target={"_blank"} rel={"noreferrer"}>{resources.common.learnMore}</a>
                </div>
            );
        }
    }
    return null;
};